import React from 'react';
import {API_BASE_URL, PAGINATION_DEFAULT_LIMIT} from '../../../helpers/constants';
import ReactTable from 'react-table';
import {I18n} from '../../../I18n/components/promoPage';
import Pagination from '../../Pagination/Pagination';
import './offerStatList.css';
import noImg from '../../../assets/images/img-error.svg';

const OfferStatList = props => {
    const {stat } = props;
    let firstElementNumber = props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
    const tableData = stat.map((item, index) => {
        const {offer} = item;
        const redirects = item.redirectCountInDateRange;
        return {
            count_id: firstElementNumber++,
            id: offer.id,
            app: {
                name: offer.appLabel || '',
                id: offer.id
            },
            offer: offer.title,
            redirects: redirects ? redirects : 0,
            actions: (
                <div className="text-center">
                </div>
            )
        };
    });
    return (
        <div className="offerstatlist-table MyReactTableClass">
            <ReactTable
                getProps={() => {
                    return {
                        style: {
                            border: "none",
                            padding: "5px"
                        }
                    };
                }}
                getTheadProps={() => {
                    return {
                        style: {
                            boxShadow: "none",
                            padding: "10px 0",
                            fontWeight: "600"
                        }
                    };
                }}
                getTheadThProps={() => {
                    return {
                        style: {
                            borderRight: "none"
                        }
                    };
                }}
                getTdProps={() => {
                    return {
                        style: {
                            borderRight: "none",
                            textAlign: "center"
                        }
                    };
                }}
                getTrProps={() => {
                    return {
                        style: {
                            alignItems: "center",
                            minHeight: "45px"
                        }
                    };
                }}
                getNoDataProps={() => {
                    return {
                        style: {
                            top: "100%"
                        }
                    };
                }}
                columns={[
                    {
                        Header: "#",
                        accessor: "count_id",
                        sortable: false,
                        filterable: false,
                        style: {
                            textAlign: "left",
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                        maxWidth: 40
                    },
                    {
                        Header: `${I18n[props.lang].name}`,
                        accessor: "app",
                        sortable: true,
                        filterable: false,
                        minWidth: 200,
                        style: {
                            textAlign: "left",
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <div className="app-table__img">
                                <img
                                    src={`${API_BASE_URL}/trade/offer/icon/${row.value.id}`}
                                    alt="application logotype"
                                    className="img-fluid media-object"
                                    width="30"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = noImg
                                    }}
                                />
                                <span>{row.value.name}</span>
                            </div>
                        )
                    },
                    {
                        Header: `${I18n[props.lang].offerList_offer}`,
                        accessor: "offer",
                        sortable: false,
                        filterable: false,
                        maxWidth: 250,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        }
                    },
                    {
                        Header: `${I18n[props.lang].redirects}`,
                        accessor: "redirects",
                        sortable: false,
                        filterable: false,
                        maxWidth: 150,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        }
                    },
                ]}
                PaginationComponent={Pagination}
                nextText={">>"}
                previousText={"<<"}
                defaultPageSize={-1}
                pageSize={tableData.length}
                showPaginationBottom={props.totalPages > 1}
                className="-highlight"
                data={tableData}
                filterable
                manual
                onPageChange={props.setCurrentPage}
                page={props.currentPage}
                pages={props.totalPages}
            />
        </div>
    )
};

export default OfferStatList;



// WEBPACK FOOTER //
// ./src/components/Promo/OfferStatList/OfferStatList.js